<mat-toolbar color="primary" class="app-toolbar">
  <img src="assets/tco-logo.svg" alt="TCO logo" class="tco-logo" />
  <span class="toolbar-title">TCO LPG Bidding Platform</span>
  <span class="spacer"></span>
  <div class="auth-area" role="status" aria-live="polite">
    @if (authService.isLoading()) {
      <span class="auth-loading">Signing you in…</span>
    } @else {
      @if (authService.isSignedIn()) {
        <div class="user-info">
          <button class="user-name-button" [matMenuTriggerFor]="userMenu" [title]="'Signed in as ' + authService.userName()">
            <span class="user-name">
              {{ authService.userName() || 'Signed in' }}
            </span>
            <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
          </button>
          @if (authService.roles().length > 0) {
            <div class="user-roles">
              @for (role of authService.roles(); track role) {
                <span class="role-badge" [title]="'Role: ' + getRoleDisplayName(role)">
                  {{ getRoleDisplayName(role) }}
                </span>
              }
            </div>
          }
        </div>
        <mat-menu #userMenu="matMenu" xPosition="before" class="user-dropdown-menu">
          <button mat-menu-item (click)="logout()" class="logout-menu-item">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </mat-menu>
      } @else {
        @if (authService.error()) {
          <span class="auth-error">
            <span class="auth-error-message">We couldn't sign you in.</span>
            <a routerLink="/sign-in-failed" class="auth-error-link">Get help</a>
          </span>
        } @else {
          <span class="auth-loading">Preparing your workspace…</span>
        }
      }
    }

  </div>
</mat-toolbar>
